import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'

import { Button } from 'react-bootstrap'
import { ListItem } from '~/views'

import style from './style.css'

export default class TimerItem extends React.Component {
  
  static VIEW_TIMER_EVENT = 'viewTimer';

  static REMOVE_EVENT = 'removeTimer';

  static STOP_EVENT = 'stopTimer';

  static START_EVENT = 'startTimer';

  static SELECTED = 'select';

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  }

  onEvent( event ) {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const { item : timer, hideNavButtons } = this.props;
    
    return (
      <ListItem className={style.timerItem} 
        onEvent={this.props.onEvent}
        item={timer}
        selected={this.props.selected}
        title={timer.name}
        subtitle={timer.status ? `Started, will run ${moment( timer.when ).fromNow()}` : 'Stopped'}
        leftView={this.renderLeft( timer )}
        rightView={this.renderRight( timer, hideNavButtons )} />
    )
  }

  renderLeft() {
    return null
  }

  renderRight( timer, hideNavButtons ) {
    const control = timer.status ? (
      <Button 
        bsStyle="link"
        bsSize="large"
        className={style.stopTimer} 
        onClick={() => { this.onEvent( TimerItem.STOP_EVENT ) }}> 
        <i className="fa fa-stop" />
      </Button>
    ) : (
      <Button 
        bsStyle="link"
        bsSize="large"
        className={style.startTimer} 
        onClick={() => { this.onEvent( TimerItem.START_EVENT ) }}> 
        <i className="fa fa-play" />
      </Button>
    )

    return (
      <div>
        { !hideNavButtons && control }
        <Button bsStyle="link"
          bsSize="large"
          className={style.deleteTimer} 
          onClick={() => { this.onEvent( TimerItem.REMOVE_EVENT ) }}> 
          <i className="fa fa-trash-o" />
        </Button>

      </div>
    )
  }

}
